import { useState } from "react";
import { observer } from "mobx-react";
import { CloseSquare, Copy } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, MenuItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Alert, LoadingButton } from "@mui/lab";

const CloneSectionModal = observer(({ uiStore, section, updateData, language, category }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const save = async () => {
        setLoading(true);
        const data = await uiStore.cloneSection(section._id, language, category);
        updateData(data);
        setLoading(false);
        setShow(false);
    }

    return (
        <Box>

            <MenuItem onClick={() => setShow(true)}>
                <ListItemIcon>
                    <Copy
                        size="24"
                        variant="Bulk"
                    />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ fontSize: '14px' }}>Clone</ListItemText>
            </MenuItem>


            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px', width: '450px' }, variant: 'round' }}
            >
                <DialogTitle>
                    Clone {section.name} Section
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Alert severity="info">Cloning a section will replace section information with information from Primary Language</Alert>
                    <Typography sx={{mt: 2}}>Are you sure you want to clone this section?</Typography>
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={() => setShow(false)} variant="contained" color="lightblue">
                        Cancel
                    </LoadingButton>
                    <LoadingButton loading={!!loading} onClick={save} variant="contained" color="secondary">
                        Clone
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box >
    );
});

export default CloneSectionModal;
